import { Link } from "react-router-dom";

const courses = [
  {
    id: "course-1",
    title: "瑜伽入门：从零到精通的21天训练营",
    instructor: "林教练",
    level: "入门",
    duration: "21天",
    students: 38920,
    image: "https://readdy.ai/api/search-image?query=Woman%20practicing%20yoga%20in%20bright%20modern%20studio%20with%20natural%20light%2C%20peaceful%20atmosphere%2C%20clean%20wooden%20floor%2C%20wellness%20lifestyle%20photography%2C%20minimalist%20interior&width=600&height=400&seq=yunsports-course-1&orientation=landscape",
  },
  {
    id: "course-2",
    title: "燃脂搏击：高强度HIIT训练课程",
    instructor: "王教练",
    level: "中级",
    duration: "12周",
    students: 25640,
    image: "https://readdy.ai/api/search-image?query=People%20doing%20high%20intensity%20boxing%20workout%20in%20modern%20gym%2C%20dynamic%20action%2C%20professional%20fitness%20photography%2C%20clean%20bright%20lighting%2C%20motivational%20atmosphere&width=600&height=400&seq=yunsports-course-2&orientation=landscape",
  },
  {
    id: "course-3",
    title: "普拉提核心训练：塑造完美体态",
    instructor: "陈教练",
    level: "入门",
    duration: "8周",
    students: 19800,
    image: "https://readdy.ai/api/search-image?query=People%20practicing%20pilates%20on%20reformer%20machine%20in%20bright%20clean%20studio%2C%20professional%20fitness%20photography%2C%20natural%20lighting%2C%20minimalist%20interior%20design&width=600&height=400&seq=yunsports-course-3&orientation=landscape",
  },
  {
    id: "course-4",
    title: "街舞基础：释放你的舞蹈天赋",
    instructor: "赵教练",
    level: "入门",
    duration: "6周",
    students: 32150,
    image: "https://readdy.ai/api/search-image?query=Street%20dance%20class%20in%20modern%20dance%20studio%20with%20mirror%20walls%2C%20young%20people%20dancing%2C%20dynamic%20movement%2C%20bright%20lighting%2C%20urban%20style%20photography&width=600&height=400&seq=yunsports-course-4&orientation=landscape",
  },
];

export default function RecommendedCourses() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">推荐课程</h2>
            <p className="text-foreground-600 text-sm">体系化专业运动课程，助你全面提升</p>
          </div>
          <Link
            to="/category/yundongkecheng"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {courses.map((course) => (
            <Link
              key={course.id}
              to="/category/yundongkecheng"
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300"
            >
              <div className="h-52 overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-3 line-clamp-2">{course.title}</h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mb-3 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-user-line w-3 h-3 flex items-center justify-center"></i>
                    {course.instructor}
                  </span>
                  <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {course.level}
                  </span>
                  <span>{course.duration}</span>
                </div>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-group-line w-3 h-3 flex items-center justify-center"></i>
                  {course.students.toLocaleString()} 人已加入
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}